import React from 'react';

function CategoryIcon({ fill, className }) {
  return (
    <svg
      className={className}
      // width="30"
      // height="30"
      viewBox="0 0 30 30"
      fill={`${fill}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.75 13.4375H21.25C18.225 13.4375 16.5625 11.775 16.5625 8.75V6.25C16.5625 3.225 18.225 1.5625 21.25 1.5625H23.75C26.775 1.5625 28.4375 3.225 28.4375 6.25V8.75C28.4375 11.775 26.775 13.4375 23.75 13.4375ZM21.25 3.4375C19.275 3.4375 18.4375 4.275 18.4375 6.25V8.75C18.4375 10.725 19.275 11.5625 21.25 11.5625H23.75C25.725 11.5625 26.5625 10.725 26.5625 8.75V6.25C26.5625 4.275 25.725 3.4375 23.75 3.4375H21.25Z"
        fill={`${fill}`}
      />
      <path
        d="M8.75 28.4375H6.25C3.225 28.4375 1.5625 26.775 1.5625 23.75V21.25C1.5625 18.225 3.225 16.5625 6.25 16.5625H8.75C11.775 16.5625 13.4375 18.225 13.4375 21.25V23.75C13.4375 26.775 11.775 28.4375 8.75 28.4375ZM6.25 18.4375C4.275 18.4375 3.4375 19.275 3.4375 21.25V23.75C3.4375 25.725 4.275 26.5625 6.25 26.5625H8.75C10.725 26.5625 11.5625 25.725 11.5625 23.75V21.25C11.5625 19.275 10.725 18.4375 8.75 18.4375H6.25Z"
        fill={`${fill}`}
      />
      <path
        d="M7.5 13.4375C4.225 13.4375 1.5625 10.775 1.5625 7.5C1.5625 4.225 4.225 1.5625 7.5 1.5625C10.775 1.5625 13.4375 4.225 13.4375 7.5C13.4375 10.775 10.775 13.4375 7.5 13.4375ZM7.5 3.4375C5.2625 3.4375 3.4375 5.2625 3.4375 7.5C3.4375 9.7375 5.2625 11.5625 7.5 11.5625C9.7375 11.5625 11.5625 9.7375 11.5625 7.5C11.5625 5.2625 9.7375 3.4375 7.5 3.4375Z"
        fill={`${fill}`}
      />
      <path
        d="M22.5 28.4375C19.225 28.4375 16.5625 25.775 16.5625 22.5C16.5625 19.225 19.225 16.5625 22.5 16.5625C25.775 16.5625 28.4375 19.225 28.4375 22.5C28.4375 25.775 25.775 28.4375 22.5 28.4375ZM22.5 18.4375C20.2625 18.4375 18.4375 20.2625 18.4375 22.5C18.4375 24.7375 20.2625 26.5625 22.5 26.5625C24.7375 26.5625 26.5625 24.7375 26.5625 22.5C26.5625 20.2625 24.7375 18.4375 22.5 18.4375Z"
        fill={`${fill}`}
      />
    </svg>
  );
}

export default CategoryIcon;
